const removedNodesContainModal = (mutations) =>
  mutations.some((mutation) =>
    Array.from(mutation.removedNodes).some((node) =>
      node.nodeType === 1 && (node.matches('.modal') || node.querySelector('.modal'))
    )
  );

export const enableModalCleanup = () => {
  new MutationObserver((mutations) => {
    if (!removedNodesContainModal(mutations)) return;

    const openModalCount = document.querySelectorAll('.modal.show').length;
    const backdrops = Array.from(document.querySelectorAll('.modal-backdrop'));
    backdrops.slice(openModalCount).forEach((backdrop) => backdrop.remove());

    if (openModalCount === 0) {
      document.body.classList.remove('modal-open');
    }
  }).observe(document.body, { childList: true, subtree: true });
};
